/*
 * @Descripttion: 电商供应商订单发票录入页
 * @Author: cb4786
 * @Date: 2023-08-10 16:57:56
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-07 11:14:31
 */

import { Button, Row, Space, Tooltip } from 'antd'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import UseLanderInvoiceEntryHook from './hooks'
import Styles from './styles.module.scss'
import { QuestionCircleOutlined } from '@ant-design/icons'
import _ from 'lodash'
import { orderDetailLinkRender } from '../../orderassurance/Lander'
import IframeModal from '../../../components/IframeModal'
import { formatTime } from '@/tools/util'
// 订单状态字典
export const orderStateDict = {
  待履约: {
    numstr: '1',
    name: '待履约',
  },
  履约中: {
    numstr: '2',
    name: '履约中',
  },
  待验收: {
    numstr: '3',
    name: '待验收',
  },
  已完成: {
    numstr: '4',
    name: '已完成',
  },
  已取消: {
    numstr: '5',
    name: '已取消',
  },
  已退货: {
    numstr: '6',
    name: '已退货',
  },
  已撤回: {
    numstr: '7',
    name: '已撤回',
  },
}
export const orderStateDictInvert = _.mapKeys(orderStateDict, (o) => o.numstr)

const LanderInvoiceEntry = () => {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
  } = UseLanderInvoiceEntryHook()
  const { dataSource, invoiceTip, pages, loading } = state
  const columns = [
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
      render: orderDetailLinkRender,
    },
    {
      key: 'customer',
      dataIndex: 'customer',
      title: '客户名称',
    },
    {
      key: 'receiveMan',
      dataIndex: 'receiveMan',
      title: '收件人',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'titleOfTheContract',
      title: '签约抬头',
      titleRender: () => (
        <>
          签约抬头
          <Tooltip
            title="此订单与咸亨实际的合同签约抬头，发票的购方和最终咸亨打款账户均以此抬头为准"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
          </Tooltip>
        </>
      ),
      render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
    },
    {
      key: 'finalPrice',
      dataIndex: 'finalPrice',
      title: '最终结算金额',
    },
    {
      key: 'signVoucherState',
      dataIndex: 'signVoucherState',
      title: '签收凭证',
    },
    {
      key: 'returnState',
      dataIndex: 'returnState',
      title: '对账完毕',
    },
    {
      key: 'dispatchTime',
      dataIndex: 'dispatchTime',
      title: '派单时间',
      render: (text: any) => formatTime(text),
    },
    {
      key: 'orderTime',
      dataIndex: 'orderTime',
      title: '下单时间',
    },
  ]
  return (
    <div className={Styles['container']}>
      <Search
        fieldsData={[
          'orderNo',
          'customer',
          'receiveMan',
          'platform',
          'signVoucher',
          'customerPayback',
          'orderTimeStart',
          'orderTimeEnd',
          'dispatchTimeStart',
          'dispatchTimeEnd',
        ]}
        onSearch={handleSearchClick}
        keyName="LANDERINVOICEENTRY"
        ScreenKey="LANDERINVOICEENTRY"
      />
      <Row justify="space-between" className={Styles['info-row']}>
        <Space style={{ cursor: 'pointer' }}>
          <Tooltip title="订单全部发货">
            <QuestionCircleOutlined style={{ marginRight: '8px' }} />
            可开票订单条件
          </Tooltip>
        </Space>
        <Space>
          <Button size="middle" onClick={() => changeInvoiceTip(true)}>
            开票要求
          </Button>
          <Button size="middle" onClick={exportDetails}>
            明细导出
          </Button>
          <Button type="primary" size="middle" onClick={handleBatchRecord}>
            发票录入
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize={true}
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>
      {/* 开票要求 */}
      <IframeModal
        open={invoiceTip}
        closeModal={() => changeInvoiceTip(false)}
        srcUrl="https://alidocs.dingtalk.com/i/p/Dnb9XJD9MAgGyAp7VJqzq2dJVg4eEXYE"
      />
    </div>
  )
}

export default LanderInvoiceEntry
/*
 * @Descripttion: 电商供应商订单发票录入页
 * @Author: cb4786
 * @Date: 2023-08-10 16:57:56
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-07 11:14:31
 */

import { Button, Row, Space, Tooltip } from 'antd'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import UseLanderInvoiceEntryHook from './hooks'
import Styles from './styles.module.scss'
import { QuestionCircleOutlined } from '@ant-design/icons'
import _ from 'lodash'
import { orderDetailLinkRender } from '../../orderassurance/Lander'
import IframeModal from '../../../components/IframeModal'
import { formatTime } from '@/tools/util'
// 订单状态字典
export const orderStateDict = {
  待履约: {
    numstr: '1',
    name: '待履约',
  },
  履约中: {
    numstr: '2',
    name: '履约中',
  },
  待验收: {
    numstr: '3',
    name: '待验收',
  },
  已完成: {
    numstr: '4',
    name: '已完成',
  },
  已取消: {
    numstr: '5',
    name: '已取消',
  },
  已退货: {
    numstr: '6',
    name: '已退货',
  },
  已撤回: {
    numstr: '7',
    name: '已撤回',
  },
}
export const orderStateDictInvert = _.mapKeys(orderStateDict, (o) => o.numstr)

const LanderInvoiceEntry = () => {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
  } = UseLanderInvoiceEntryHook()
  const { dataSource, invoiceTip, pages, loading } = state
  const columns = [
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
      render: orderDetailLinkRender,
    },
    {
      key: 'customer',
      dataIndex: 'customer',
      title: '客户名称',
    },
    {
      key: 'receiveMan',
      dataIndex: 'receiveMan',
      title: '收件人',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'titleOfTheContract',
      title: '签约抬头',
      titleRender: () => (
        <>
          签约抬头
          <Tooltip
            title="此订单与咸亨实际的合同签约抬头，发票的购方和最终咸亨打款账户均以此抬头为准"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
          </Tooltip>
        </>
      ),
      render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
    },
    {
      key: 'finalPrice',
      dataIndex: 'finalPrice',
      title: '最终结算金额',
    },
    {
      key: 'signVoucherState',
      dataIndex: 'signVoucherState',
      title: '签收凭证',
    },
    {
      key: 'returnState',
      dataIndex: 'returnState',
      title: '对账完毕',
    },
    {
      key: 'dispatchTime',
      dataIndex: 'dispatchTime',
      title: '派单时间',
      render: (text: any) => formatTime(text),
    },
    {
      key: 'orderTime',
      dataIndex: 'orderTime',
      title: '下单时间',
    },
  ]
  return (
    <div className={Styles['container']}>
      <Search
        fieldsData={[
          'orderNo',
          'customer',
          'receiveMan',
          'platform',
          'signVoucher',
          'customerPayback',
          'orderTimeStart',
          'orderTimeEnd',
          'dispatchTimeStart',
          'dispatchTimeEnd',
        ]}
        onSearch={handleSearchClick}
        keyName="LANDERINVOICEENTRY"
        ScreenKey="LANDERINVOICEENTRY"
      />
      <Row justify="space-between" className={Styles['info-row']}>
        <Space style={{ cursor: 'pointer' }}>
          <Tooltip title="订单全部发货">
            <QuestionCircleOutlined style={{ marginRight: '8px' }} />
            可开票订单条件
          </Tooltip>
        </Space>
        <Space>
          <Button size="middle" onClick={() => changeInvoiceTip(true)}>
            开票要求
          </Button>
          <Button size="middle" onClick={exportDetails}>
            明细导出
          </Button>
          <Button type="primary" size="middle" onClick={handleBatchRecord}>
            发票录入
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize={true}
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>
      {/* 开票要求 */}
      <IframeModal
        open={invoiceTip}
        closeModal={() => changeInvoiceTip(false)}
        srcUrl="https://alidocs.dingtalk.com/i/p/Dnb9XJD9MAgGyAp7VJqzq2dJVg4eEXYE"
      />
    </div>
  )
}

export default LanderInvoiceEntry
